import { render, staticRenderFns } from "./EnquiryStatusChip.vue?vue&type=template&id=d6207bce&scoped=true&"
import script from "./EnquiryStatusChip.vue?vue&type=script&lang=js&"
export * from "./EnquiryStatusChip.vue?vue&type=script&lang=js&"
import style0 from "./EnquiryStatusChip.vue?vue&type=style&index=0&id=d6207bce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6207bce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VTooltip})
